<template>
    <div class="hiq-public-art__search">
        <form class="hiq-public-art__search--form" action="" method="get" @submit.prevent="search">
            <label class="show-for-sr" for="hiq-public-art-search">{{translations.searchWord}}</label>
            <input class="hiq-public-art__search--input" id="hiq-public-art-search" type="text" v-model="query" name="query" :placeholder="translations.searchWord"/>
            <input class="hiq-public-art__search--submit" type="submit" :value="translations.search"/>
        </form>
        <p class="hiq-public-art__search--description">
            <strong>{{translations.searchBy}}:</strong>
            <span>{{translations.searchDescription}}</span>
        </p>
    </div>
</template>

<script>
import { newSearch } from '../store/actions';
export default {
    name: 'search',
    data() {
        return {
            query: '',
        }
    },
    methods: {
        search() {
            this.$store.commit({
                type: 'setQuery',
                payload: this.query,
            });
            this.$store.dispatch(newSearch());
        }
    },
    computed: {
        translations() {
            return this.$store.state.translations;
        }
    },
    mounted() {
        if(this.$store.state.art.query && this.$store.state.art.query !== '*') {
            this.query = this.$store.state.art.query;
        }
    }
}
</script>